import { createFileRoute } from "@tanstack/react-router";
import SupportTicketPage from "@/site/pages/support-ticket";

export const Route = createFileRoute("/support/ticket/$token")({
  component: SupportTicketPage,
});
